/* eslint-disable prettier/prettier */
import { createStore } from "vuex";

const flattenTranslations = (trns, lang) => {
  const obj = {};

  Object.keys(trns || {}).forEach((key) => {
    obj[key] = trns[key][lang];
  });

  return obj;
};

export default createStore({
  state: {
    dataTrans: {},
    translation: {},
    dataTranslation: {},
    trans: {},
    loading: false,
  },
  getters: {},
  mutations: {
    setTranslationData: (state, payload) => {
      state.dataTrans = payload;
    },
    setLoading: (state, payload) => {
      state.loading = payload;
    },
    setLang: (state, payload) => {
      state.translation = payload;
    },
    setTransData(state, payload) {
      state.dataTranslztion = payload;
    },
    setLang2(state, payload) {
      state.trans = payload;
    },
  },
  actions: {
    async setTranslations({ commit }) {
      const lang = localStorage.getItem("lang") || "en";
      const applyTranslations = (trns) => {
        if (!trns) return;

        const obj = flattenTranslations(trns, lang);

        commit("setLang2", obj);
      };

      try {
        const cachedTranslations = localStorage.getItem("lang2");

        if (cachedTranslations) {
          applyTranslations(JSON.parse(cachedTranslations));
        }
      } catch (error) {
        localStorage.removeItem("lang2");
      }

      try {
        const { appTranslation } = await import("@/services/Translation");
        const trns = await appTranslation();

        if (trns) {
          localStorage.setItem("lang2", JSON.stringify(trns));
          applyTranslations(trns);
        }
      } catch (error) {
        // Keep the cached translations when the remote request fails.
      }
    },

    setLanguage({ state, commit }, lang = "en") {
      const object = state?.dataTrans;
      const data = {};

      for (const key in object) {
        const dataArray = object[key];

        if (key === "Home") {
          const makeObj = {};
          dataArray?.forEach((item) => {
            for (const key1 in item) {
              makeObj[key1] = item[key1][lang];
            }
          });
          data[key] = makeObj;
        } else {
          const profiles = dataArray.map((item) => item);
          data[key] = profiles;
        }
      }

      commit("setLang", data);
    },
  },
  modules: {},
});
